import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const steps = [
  {
    num: '01',
    icon: 'ri-chat-check-line',
    title: 'Вы оставляете заявку',
    desc: 'Пишете нам в Telegram или через форму на сайте. Уточняем нишу бизнеса, объём базы, цели рассылки и желаемый результат.',
    accent: 'bg-primary-100 text-primary-700',
  },
  {
    num: '02',
    icon: 'ri-database-2-line',
    title: 'Готовим базу и аккаунты',
    desc: 'Вы передаёте свою базу контактов — или мы собираем её с нашей стороны. Подготавливаем номера, прогреваем аккаунты перед запуском.',
    accent: 'bg-primary-500 text-background-50',
  },
  {
    num: '03',
    icon: 'ri-send-plane-fill',
    title: 'Запускаем рассылку',
    desc: 'Отправляем персонализированные сообщения с наших номеров через Telegram, WhatsApp и Max. Контролируем доставляемость и процент прочтений.',
    accent: 'bg-primary-100 text-primary-700',
  },
  {
    num: '04',
    icon: 'ri-bar-chart-box-line',
    title: 'Передаём результат',
    desc: 'Собираем ответы, фиксируем заинтересованных. Вы получаете отчёт: сколько отправлено, доставлено, прочитано и сколько лидов получено.',
    accent: 'bg-primary-100 text-primary-700',
  },
];

export default function MMProcess() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 100 });
  const { ref: descRef, revealed: descRevealed } = useScrollReveal({ delay: 200 });
  const { containerRef: stepsRef, revealedCount: stepsRevealed } = useScrollRevealGroup<HTMLDivElement>(4);

  return (
    <section id="mm-process" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span ref={labelRef} className={`text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}>
            Процесс
          </span>
          <h2 ref={titleRef} className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}>
            Как мы работаем
          </h2>
          <p ref={descRef} className={`mt-3 text-[14.5px] text-foreground-500 max-w-lg mx-auto reveal-fade-up ${descRevealed ? 'revealed' : ''}`}>
            Четыре простых шага от заявки до готового отчёта. Никакой магии — только системный подход.
          </p>
        </div>

        <div ref={stepsRef} className="relative max-w-3xl mx-auto">
          <div className="absolute left-[19px] top-10 bottom-10 w-px bg-background-300/60 hidden md:block" />

          <div className="flex flex-col gap-8 md:gap-10">
            {steps.map((step, i) => (
              <div key={step.num} className={`relative flex gap-5 md:gap-8 items-start reveal-fade-up ${i < stepsRevealed ? 'revealed' : ''}`} style={i < stepsRevealed ? { transitionDelay: `${i * 150}ms` } : undefined}>
                <div className={`relative z-10 flex-shrink-0 w-10 h-10 rounded-full ${step.accent} flex items-center justify-center font-heading font-bold text-sm`}>
                  {step.num}
                </div>

                <div className="flex-1 bg-background-100 rounded-2xl border border-background-200 p-5 md:p-6 hover:border-primary-500/40 transition-all duration-300">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center text-primary-600">
                      <i className={`${step.icon} text-sm`}></i>
                    </span>
                    <h3 className="font-display font-bold text-[18px] text-foreground-950">
                      {step.title}
                    </h3>
                  </div>
                  <p className="text-[14.5px] text-foreground-500 leading-relaxed">
                    {step.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}